import { Text, EmbeddedContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { formatLabelForId, generateRandomString } from '../../utils';
import { InputTextField } from '../components';

type Props = {
  field: Text;
  index: number;
};

export const CustomTextField = ({ field, index }: Props) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { elements } = liveTemplate.mediumData as EmbeddedContentDefinition;
  const customFields = elements?.text || [];
  const setCustomFields = (updatedFields: Text[]) => {
    const newElements = {
      ...elements,
      text: updatedFields.length ? updatedFields : null,
    };
    setCurrentMediumField('elements', newElements);
  };

  const updateAtCurrentIndex = (updatedField: Text) => {
    const updatedFieldsList = [...customFields];
    updatedFieldsList[index] = updatedField;
    setCustomFields(updatedFieldsList);
  };

  const handleLabelChange = (label: string) => {
    const id = `${formatLabelForId(label)}-${generateRandomString()}`;
    const updatedField = { ...field, id, label };
    updateAtCurrentIndex(updatedField);
  };

  const handleValueChange = (text: string) => {
    const updatedField = { ...field, text };
    updateAtCurrentIndex(updatedField);
  };

  const handleDelete = () => {
    const updatedFieldsList = [...customFields];
    updatedFieldsList.splice(index, 1);
    setCustomFields(updatedFieldsList);
  };

  return (
    <InputTextField
      label={field.label || ''}
      setLabel={handleLabelChange}
      value={field.text || ''}
      setValue={handleValueChange}
      onDelete={handleDelete}
    />
  );
};
